<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable.vue";

export default {
  name: 'Devices',
  components: {CommonTable},
  data() {
    return {
      searchs: [/*{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      }*/],
      permission: {
        add: 'devices:add',
        update: 'devices:update',
        delete: 'devices:delete',
        deleteBatch: 'devices:deleteBatch'
      },
      url: {
        get: '/devices/listByCondition',
        add: '/devices/add',
        update: '/devices/update',
        delete: '/devices/delete',
        delete_batch: '/devices/deleteBatch',
        status: '/devices/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }/*, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }*/,
        {
          field: 'number',  // 字段名
          label: '设备编号',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'remark',  // 字段名
          label: '备注',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
        }, {
          field: 'status',  // 字段名
          label: '状态',  // 字段显示名称
          sort: false,  // 是否排序
          show: true,  // 是否展示
          status: true,
        },
        {
          field: 'createTime',
          label: '时间',
          show: true,
          width: '',
        }

      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'number',  // 字段名
            label: '设备编号',  // 字段显示名称
            type: 'input',
            placeholder: '请输入设备编号',
            rules: [
              {required: true, message: '设备编号不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'remark',  // 字段名
            label: '备注',  // 字段显示名称
            type: 'input',
            placeholder: '请输入备注',
            rules: [],
            add: true,
            update: true,
          }, {
            field: 'status',  // 字段名
            label: '状态',  // 字段显示名称
            type: 'select',
            selectData: [{
              id: 1,
              name: "启用"
            }, {
              id: 0,
              name: '禁用'
            }],
            placeholder: '请选择状态',
            rules: [
              {required: true, message: '状态不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
